import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

import Loadable from 'components/Loadable';
import PublicRoutes from './PublicRoutes';
import AuthRoutes from './AuthRoutes';
import MainRoutes from './MainRoutes';

const Error404 = Loadable(lazy(() => import('pages/maintenance/404')));

// ==============================|| ROUTING RENDER ||============================== //

export const router = createBrowserRouter([
  PublicRoutes,
  AuthRoutes,
  MainRoutes,
  {
    path: '*',
    element: <Error404 />
  }
]);
